import { useQuery } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { formatAndPrintPDFResponse, handleQueryError } from 'utils/helpers'
import { getReturoMaterialLabel, getReturoScanLabel } from './helpers'

export const getReturoSealCounter = (showNotification: Function) => {
  return useQuery(
    ['returo-seal-counter'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception-mobile/returo/seal-counter')

      return result
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea counter-ului pentru sigilii din returo.',
          showNotification
        )
    }
  )
}

export const getReturoMaterialTypeOptions = (showNotification: Function) => {
  return useQuery(
    ['returo-material-type-options'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception-mobile/returo/material-types')

      const resultOptions = result.map(
        (item: string): AutocompleteOption => ({
          label: getReturoMaterialLabel(item),
          value: item
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de material.',
          showNotification
        )
    }
  )
}

export const getReturoScanTypeOptions = (showNotification: Function) => {
  return useQuery(
    ['returo-scan-type-options'],
    async () => {
      const result = await makeCoreGetRequest('/shop-reception-mobile/returo/scan-types')

      const resultOptions = result.map(
        (item: string): AutocompleteOption => ({
          label: getReturoScanLabel(item),
          value: item
        })
      )

      return resultOptions || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea tipurilor de scanare.',
          showNotification
        )
    }
  )
}

export const getInProgressInventoriedSeals = (showNotification: Function) => {
  return useQuery(
    ['returo-in-progress-inventoried-seals'],
    async () => {
      const result = await makeCoreGetRequest(
        '/shop-reception-mobile/returo/seals?status=INVENTORIED'
      )

      return result || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea sigiliilor din inventar.',
          showNotification
        )
    }
  )
}

export const getInDeliverySeals = (showNotification: Function, setSelectedSeals: Function) => {
  return useQuery(
    ['returo-in-delivery-seals'],
    async () => {
      const result = await makeCoreGetRequest(
        '/shop-reception-mobile/returo/seals?status=IN_DELIVERY'
      )

      setSelectedSeals(result || [])

      return result || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea sigiliilor in livrare.',
          showNotification
        )
    }
  )
}

export const printReturoReportPDF = (showNotification: Function, reportId: number) => {
  return useQuery(
    ['print-returo-report-PDF', reportId],
    async () => {
      return await makeCoreGetRequest(
        `/shop-reception-mobile/returo/notice-as-pdf/${reportId}`,
        {
          responseType: 'blob'
        }
      )
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la deschiderea de print preview a fisierului.',
          showNotification
        )
    }
  )
}

export const getInProgressReports = (showNotification: Function, setSelectedReports: Function) => {
  return useQuery(
    ['returo-in-progress-reports'],
    async () => {
      const result = await makeCoreGetRequest(
        '/shop-reception-mobile/returo/notices?status=IN_PROGRESS'
      )

      setSelectedReports(result || [])

      return result || []
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea listei de PV-uri.',
          showNotification
        )
    }
  )
}
